"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitflapWebSerial = void 0;
const splitflapjs_core_1 = require("splitflapjs-core");
class SplitflapWebSerial extends splitflapjs_core_1.SplitflapCore {
    constructor(port, onMessage) {
        super(onMessage, (packet) => {
            var _a;
            (_a = this.writer) === null || _a === void 0 ? void 0 : _a.write(packet).catch(this.onError);
        });
        this.writer = undefined;
        this.port = port;
        this.portAvailable = true;
        this.onStart();
        this.port.addEventListener('disconnect', () => {
            console.log('shutting down on disconnect');
            this.port = null;
            this.portAvailable = false;
        });
    }
    openAndLoop() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.port === null) {
                return;
            }
            yield this.port.open({ baudRate: splitflapjs_core_1.SplitflapCore.BAUD });
            if (this.port.readable === null || this.port.writable === null) {
                throw new Error('Port missing readable or writable!');
            }
            const reader = this.port.readable.getReader();
            try {
                const writer = this.port.writable.getWriter();
                writer.write(Uint8Array.from([0, 0, 0, 0, 0, 0, 0, 0])).catch(this.onError);
                this.writer = writer;
                try {
                    // eslint-disable-next-line no-constant-condition
                    while (true) {
                        const { value, done } = yield reader.read();
                        if (done) {
                            break;
                        }
                        if (value !== undefined) {
                            this.onReceivedData(value);
                        }
                    }
                }
                finally {
                    console.log('Releasing writer');
                    writer === null || writer === void 0 ? void 0 : writer.releaseLock();
                }
            }
            finally {
                console.log('Releasing reader');
                reader.releaseLock();
            }
        });
    }
    onError(e) {
        var _a;
        console.error('Error writing serial', e);
        (_a = this.port) === null || _a === void 0 ? void 0 : _a.close();
        this.port = null;
        this.portAvailable = false;
        this.writer = undefined;
    }
}
exports.SplitflapWebSerial = SplitflapWebSerial;
